import { ApiKey } from "../apiKeys";
import { checkTokenValidation } from "../auth/tokenReq";
import { authAxios } from "../config";

export const getPlansListReq = async () => {
  const logfun = (d: any, t: string) =>
    console.log(d, new Date() + ": plansReq->getPlansListReq " + t);
  try {
    await checkTokenValidation();

    const res = await authAxios.get(`${ApiKey.getPlansListKey}`);
    // logfun(res?.data, "res");
    const resData = res?.data;
    const plansData = resData?.plansObj || [];
    const _data = plansData?.map((item: any) => ({
      subscriptionID: item?.subscriptionID || "",
      subscriptionName: item?.subscriptionName || "",
      subscriptionFees: item?.subscriptionFees || "",
      subscriptionDuration: item?.subscriptionDuration || "",
    }));
    return { error: false, data: _data, message: "", errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err?.response?.data?.message || "Response Error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const updateSubscriptionDetailsReq = async (
  params: { companyID: any },
  props: { subscriptionID: number; subscriptionValidUpto: string }
) => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": plansReq->updateSubscriptionDetailsReq " + t
    );
  try {
    await checkTokenValidation();
    const body = props;
    const res = await authAxios.post(
      `${ApiKey.updateSubscriptionDetailsKey}/${params?.companyID}/subscription`,
      body
    );
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const _data = null;
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
